import React, { Fragment, useEffect } from "react";
import { Form, Input, Button, message } from "antd";
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { MailIcon, LockIcon } from "components/icons";
import { useSetpassword } from 'hooks/auth/Auth';
import { strongPasswordRule } from "helpers/commonFunctions";

const VALIDATE_ON_BLUR = ["onBlur"];

const SetPassword = () => {
    let navigate = useNavigate();
    const [form] = Form.useForm();
    const search = useLocation().search;
    const email = new URLSearchParams(search).get('email');

    const { mutate: setPassword, isLoading: Loading } = useSetpassword();

    useEffect(() => {
        if (!email) {
            navigate("/forgotPassword", { replace: true });
        }
    }, [email, navigate]);

    const onFinish = (values) => {
        setPassword(values, {
            onSuccess: (item) => {
                if (item?.statusCode === 200) {
                    message.success(item?.message)
                    navigate("/login");
                }
                else {
                    message.error(item?.message)
                }
            },
            onError: (error) => {
                console.log(error)
            }
        });
    }

    return (
        <Fragment>
            <h2>Set New Password</h2>
            <p>Strong passwords, strong security.</p>

            <Form
                form={form}
                onFinish={onFinish}
                autoComplete="off"
                name="setPassword_info"
                layout="vertical"
                initialValues={{
                    "email": email,
                }}>
                <Form.Item name="email" rules={[{ required: true, type: "email" }]}>
                    <Input prefix={<MailIcon />} disabled={true} maxLength={254} />
                </Form.Item>
                <Form.Item
                    className="password"
                    name="newPassword"
                    validateTrigger={VALIDATE_ON_BLUR}
                    rules={[
                        { required: true, message: "Enter your new password!" },
                        strongPasswordRule,
                    ]}>
                    <Input.Password prefix={<LockIcon />} className="passwordInput" placeholder="New password" autoComplete="new-password" />
                </Form.Item>
                <Form.Item
                    className="password"
                    name="confirmPassword"
                    dependencies={["newPassword"]}
                    validateTrigger={VALIDATE_ON_BLUR}
                    rules={[
                        { required: true, message: "Re-enter your new password!" },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue("newPassword") === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("Both passwords must match!"));
                            },
                        }),
                    ]}>
                    <Input.Password prefix={<LockIcon />} className="passwordInput" placeholder="Confirm new password" autoComplete="new-password" />
                </Form.Item>
                <Form.Item>
                    <Button loading={Loading} htmlType="submit" type="primary" block>Submit</Button>
                </Form.Item>
            </Form>

            <p className="login-card-foot">
                <Link to={"/login"}>Back to login</Link>
            </p>
        </Fragment >
    );
}

export default SetPassword;
